import { render, staticRenderFns } from "./EmployeeRecruitment.vue?vue&type=template&id=b0cb11ec&scoped=true"
import script from "./EmployeeRecruitment.vue?vue&type=script&lang=js"
export * from "./EmployeeRecruitment.vue?vue&type=script&lang=js"
import style0 from "./EmployeeRecruitment.vue?vue&type=style&index=0&id=b0cb11ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cb11ec",
  null
  
)

export default component.exports